
import { Component, Vue } from "vue-property-decorator";
import { DimssaButton, ButtonState } from "@/components/shared/dimssa-button.vue";
import colors from "vuetify/lib/util/colors";
import lodash from "lodash";
import * as Model from "@gigalot/data-models";
import BreadcrumbTrail from "@/components/BreadcrumbTrail.vue";
import { homeBreadcrumbs } from "@/utils/breadcrumbs";
interface KraalDeliverySummary {
  label: string;
  allocated: number;
  fed: number;
  active: boolean;
}
interface KraalDetail {
  kraalId: string;
  description?: string;
  ration?: string;
  rationColor?: string;
  feedAllocated: number;
  actualFed: number;
  progressPercent: number;
  deliveries: KraalDeliverySummary[];
  numberAnimals?: number;
  daysInFeedlot?: number;
  projectedDaysInFeedlot?: number;
  lotDescription?: string;
  owner?: string;
  notes?: string;
}
const { gmapApi } = require("vue2-google-maps");
const Subscriber = require("@jetblack/graphql-reconnect-client");
import { createClient } from "@/helpers/graphql-ws-rtc-adapter";
@Component({
  components: {
    DimssaButton,
    BreadcrumbTrail,
  },
})
export default class Map extends Vue {
  name = "Map";
  icon = {
    url: "./img/tractor.png",
    scaledSize: { width: 50, height: 50 },
  };
  gpsCoordinates = [];
  gpsCenter: any = { lat: 0, lng: 0 };
  loading = false;
  replays: any = undefined;
  kmlFilename = "";
  playbackDate = "";
  date = new Date().toISOString().substr(0, 10);
  menu = false;
  headers = [
    {
      text: "Tractor",
      value: "TractorID",
      align: "center",
      sortable: true,
      filterable: true,
      divider: false,
      group: false,
    },
    {
      text: "Trailer",
      value: "TrailerID",
      align: "center",
      sortable: true,
      filterable: true,
      divider: true,
    },
    {
      text: "Ration",
      value: "Ration",
      align: "center",
      sortable: true,
      filterable: true,
      divider: true,
    },
    {
      text: "Status",
      value: "State",
      align: "center",
      sortable: true,
      filterable: true,
      divider: true,
    },
    {
      text: "Wagon Mass",
      value: "ScaleWeight",
      align: "center",
      sortable: true,
      filterable: true,
      divider: true,
    },
    {
      text: "Job Amount (kg)",
      value: "JobWeight",
      align: "center",
      sortable: true,
      filterable: true,
      divider: true,
    },
  ];
  urlws = "wss://pi.gigalot.systems:7778/api/ws";
  options = {};
  coordinateSubscription = `subscription($guid:String!) {
    gpsLocations(guid:$guid)
    }`;
  coordinateQuery = `query($guid:String!){
    GPSLocations(guid:$guid)
    }`;
  variables = { guid: this.$store.state.user.location.guid };
  operationName = null;
  setMapPoint(item: any) {
    console.log(item);
    let coordination: any = lodash.find(this.gpsCoordinates, { ID: item.TractorID });
    console.log(coordination?.latitude);
    console.log(coordination?.longitude);
    if (coordination?.latitude && coordination?.longitude) {
      let mapPromise: any = this.$refs.mapRef;
      mapPromise.$mapPromise.then((map: any) => {
        map.panTo(this.getLatLong(coordination.latitude, coordination.longitude));
        map.setZoom(20);
      });
    }
  }
  colorPalette = [
    colors.red,
    colors.green,
    colors.amber,
    colors.purple,
    colors.indigo,
    colors.teal,
    colors.lime,
    colors.deepOrange,
    colors.brown,
    colors.blueGrey,
  ];
  flightpaths: any[] = [];
  kraalDetails: Record<string, KraalDetail> = {};
  drawPolyline() {
    let palIndex = 0;
    let grouped = lodash.groupBy(this.replays, "TractorID");
    for (let group in grouped) {
      let coordinates = [];
      let sorted = lodash.sortBy(grouped[group], function (o) {
        return o.TimeTicks;
      });
      for (let item of sorted) {
        let track = { lat: item.Latitude, lng: item.Longitude };
        coordinates.push(track);
      }
      let gthis: any = globalThis;
      const flightPath = new gthis.google.maps.Polyline({
        path: coordinates,
        geodesic: true,
        strokeColor: this.colorPalette[palIndex++].base,
        strokeOpacity: 1.0,
        strokeWeight: 3,
      });
      let mapPromise: any = this.$refs.mapRef;
      mapPromise.$mapPromise.then((map: any) => {
        flightPath.setMap(map);
      });
      this.flightpaths.push(flightPath);
    }
  }
  clearTracks() {
    let mapPromise: any = this.$refs.mapRef;
    mapPromise.$mapPromise.then((map: any) => {
      for (let flightPath of this.flightpaths) {
        flightPath.setMap(null);
      }
    });
  }
  async getGPSCenter() {
    let url = `${this.$store.getters["backendUrl"]()}/gpsCenter`;
    let jwt = await this.$store.dispatch("user/getOnlineIdToken", undefined, { root: true });
    let res = await fetch(url, {
      method: "GET",
      headers: new Headers({ Authorization: `Bearer ${jwt}` }),
    });
    if (!res.ok) throw Error("Response OK : " + (await res.text()));
    let data = await res.json();
    console.log(data);
    this.gpsCenter = data;
  }
  getLatLong(lat: string, long: string) {
    try {
      let latitude = parseFloat(lat);
      let longitude = parseFloat(long);
      return { lat: latitude, lng: longitude };
    } catch (err) {}
  }
  async mounted() {
    this.loadKraalDetails();
    setTimeout(() => {
      this.getKmlFile().then(() => {
        this.loadKmlLayer();
        this.getGPSCenter();
      });
      this.getGPSCoordinates();
      this.getGPSCoordinatesSocket();
      this.getReplayTracking(this.playbackDate);
    }, 3000);
  }
  loadKmlLayer() {
    let mapPromise: any = this.$refs.mapRef;
    mapPromise.$mapPromise.then((map: any) => {
      let src = "https://feed.gigalot.co.za/kml/" + this.kmlFilename; //'https://developers.google.com/kml/documentation/KML_Samples.kml';
      let gthis: any = globalThis;
      var kmlLayer: google.maps.KmlLayer = new gthis.google.maps.KmlLayer(src, {
        suppressInfoWindows: true,
        preserveViewport: false,
        map: map,
      });
      kmlLayer.addListener("click", (kmlEvent: google.maps.KmlMouseEvent) => {
        let identifier = kmlEvent?.featureData?.name ?? "";
        let content = this.buildKraalInfoContent(identifier);
        this.infowindow.setContent(content);
        if (kmlEvent?.latLng) {
          this.infowindow.setPosition(kmlEvent.latLng);
        }
        this.infowindow.open(map);
      });
    });
  }
  infowindow = new google.maps.InfoWindow({
    content: '<div class="kraal-iw"><strong>Select a kraal to view details.</strong></div>',
  });
  async loadKraalDetails() {
    try {
      const gql = `query MapKraalDetails($guid: String!) {
        FeedPlan(guid:$guid){
          FeedingPlanItems{
            kraalId
            kraalGuid
            currentRation{
              ration
              colour
            }
            projectedDaysInFeedlot
            numberAnimals
            kraalDate
            lotDescription
            lotNote
            notes
            owner
          }
        }
        FeedSchedule(guid:$guid){
          feedingScheduleItems{
            kraalId
            ration
            feedAllocated
            actualFed
            feedAllocations{
              feedAllocated
              actualFed
              allocated
              active
            }
          }
        }
        Kraals(guid:$guid){
          guid
          kraalId
          description
        }
      }`;
      const variables = { guid: this.$store.state.user.location.guid };
      const response = await this.$store.dispatch("graphQl", { gql, variables });
      if (!response) return;
      if (response.errors && response.errors.length) {
        console.error("loadKraalDetails -> graphql errors", response.errors);
        return;
      }
      const planItems = (response?.data?.FeedPlan?.FeedingPlanItems ?? []) as Model.FeedingPlanItem[];
      const scheduleItems = (response?.data?.FeedSchedule?.feedingScheduleItems ?? []) as any[];
      const kraals = (response?.data?.Kraals ?? []) as Model.Kraal[];
      const planByKraal = lodash.keyBy(planItems, "kraalId") as Record<string, Model.FeedingPlanItem>;
      const scheduleByKraal = lodash.groupBy(scheduleItems, "kraalId") as Record<string, any[]>;
      const kraalMetaById = lodash.keyBy(kraals, "kraalId") as Record<string, Model.Kraal>;
      const detailMap: Record<string, KraalDetail> = {};
      const identifierCandidates = new Set<string>();
      Object.keys(planByKraal).forEach((id) => identifierCandidates.add(id));
      Object.keys(scheduleByKraal).forEach((id) => identifierCandidates.add(id));
      Object.keys(kraalMetaById).forEach((id) => identifierCandidates.add(id));
      identifierCandidates.forEach((kraalId) => {
        const planItem = planByKraal[kraalId];
        const scheduleList = scheduleByKraal[kraalId] ?? [];
        const meta = kraalMetaById[kraalId];
        let aggregatedRation: string | undefined;
        let feedAllocated = 0;
        let actualFed = 0;
        const deliveries: KraalDeliverySummary[] = [];
        scheduleList.forEach((item: any) => {
          feedAllocated += item?.feedAllocated ?? 0;
          actualFed += item?.actualFed ?? 0;
          if (!aggregatedRation && item?.ration) {
            aggregatedRation = item.ration;
          }
          (item?.feedAllocations ?? []).forEach((allocation: any) => {
            deliveries.push({
              label: `Delivery ${deliveries.length + 1}`,
              allocated: allocation?.feedAllocated ?? allocation?.allocated ?? 0,
              fed: allocation?.actualFed ?? 0,
              active: allocation?.active ?? false,
            });
          });
        });
        const progressPercent = feedAllocated > 0 ? Math.round(Math.min(100, (actualFed / feedAllocated) * 100)) : 0;
        const detail: KraalDetail = {
          kraalId: planItem?.kraalId ?? meta?.kraalId ?? kraalId,
          description: meta?.description,
          ration: planItem?.currentRation?.ration ?? aggregatedRation,
          rationColor: planItem?.currentRation?.colour,
          feedAllocated,
          actualFed,
          progressPercent,
          deliveries,
          numberAnimals: planItem?.numberAnimals,
          daysInFeedlot: planItem?.kraalDate ? this.calculateDaysInFeedlot(planItem.kraalDate) : undefined,
          projectedDaysInFeedlot: planItem?.projectedDaysInFeedlot,
          lotDescription: planItem?.lotDescription,
          owner: planItem?.owner,
          notes: planItem?.lotNote ?? undefined,
        };
        const identifiers = new Set<string>();
        this.normalizeIdentifiers(planItem?.kraalId).forEach((id) => identifiers.add(id));
        this.normalizeIdentifiers(planItem?.kraalGuid).forEach((id) => identifiers.add(id));
        this.normalizeIdentifiers(meta?.kraalId).forEach((id) => identifiers.add(id));
        this.normalizeIdentifiers(meta?.guid).forEach((id) => identifiers.add(id));
        this.normalizeIdentifiers(kraalId).forEach((id) => identifiers.add(id));
        identifiers.forEach((id) => {
          if (id) {
            detailMap[id] = detail;
          }
        });
      });
      this.kraalDetails = detailMap;
    } catch (err) {
      console.error("loadKraalDetails -> error:", err);
    }
  }
  normalizeIdentifiers(identifier?: string | null): string[] {
    if (!identifier) return [];
    const trimmed = identifier.trim();
    if (!trimmed) return [];
    const variations = new Set<string>();
    variations.add(trimmed);
    variations.add(trimmed.toUpperCase());
    variations.add(trimmed.toLowerCase());
    variations.add(trimmed.replace(/\s+/g, ""));
    return Array.from(variations);
  }
  getKraalDetail(identifier?: string | null): { detail?: KraalDetail; resolvedId: string } {
    const variations = this.normalizeIdentifiers(identifier);
    for (const variation of variations) {
      const detail = this.kraalDetails[variation];
      if (detail) {
        return { detail, resolvedId: detail.kraalId };
      }
    }
    const fallback = identifier ? identifier.trim() : "";
    return { detail: undefined, resolvedId: fallback };
  }
  calculateDaysInFeedlot(kraalDate: string | number): number | undefined {
    if (kraalDate === undefined || kraalDate === null) return undefined;
    const start = this.moment(kraalDate);
    if (!start || !start.isValid()) return undefined;
    const today = this.moment(Date.now());
    return today.diff(start, "days") + 1;
  }
  formatNumber(value: number | undefined, fractionDigits: number = 0): string {
    if (value === undefined || value === null || Number.isNaN(value)) {
      return "0";
    }
    try {
      return new Intl.NumberFormat(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: fractionDigits,
      }).format(value);
    } catch (err) {
      return value.toFixed(fractionDigits);
    }
  }
  escapeHtml(value: string | number | undefined | null): string {
    if (value === undefined || value === null) return "";
    return String(value).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
  }
  buildKraalInfoContent(identifier: string | undefined | null) {
    const { detail, resolvedId } = this.getKraalDetail(identifier);
    const displayId = this.escapeHtml(resolvedId || (identifier ?? "Unknown"));
    let html = `<div class="kraal-iw"><div class="kraal-iw__header">Kraal ${displayId}</div>`;
    if (detail?.description) {
      html += `<div class="kraal-iw__sub">${this.escapeHtml(detail.description)}</div>`;
    }
    if (!detail) {
      html += `<div class="kraal-iw__body"><div>No additional data available.</div></div></div>`;
      return html;
    }
    const badgeColor = detail.rationColor ? ` style="background-color:${this.escapeHtml(detail.rationColor)}; color:#ffffff;"` : "";
    const rationLabel = detail.ration ? this.escapeHtml(detail.ration) : "Not set";
    html += `<div class="kraal-iw__section"><div class="kraal-iw__meta-row"><span>Ration</span><span class="kraal-iw__badge"${badgeColor}>${rationLabel}</span></div></div>`;
    html += `<div class="kraal-iw__progress"><div class="kraal-iw__progress-fill" style="width:${detail.progressPercent}%;"></div></div>`;
    html += `<div class="kraal-iw__progress-text">${this.escapeHtml(this.formatNumber(detail.actualFed))} / ${this.escapeHtml(
      this.formatNumber(detail.feedAllocated)
    )} kg fed</div>`;
    html += `<div class="kraal-iw__meta">`;
    if (detail.numberAnimals !== undefined) {
      html += `<div class="kraal-iw__meta-row"><span>Animals</span><span>${this.escapeHtml(this.formatNumber(detail.numberAnimals))}</span></div>`;
    }
    if (detail.daysInFeedlot !== undefined && detail.projectedDaysInFeedlot !== undefined) {
      html += `<div class="kraal-iw__meta-row"><span>Days in feedlot</span><span>${detail.daysInFeedlot} / ${detail.projectedDaysInFeedlot}</span></div>`;
    } else if (detail.daysInFeedlot !== undefined) {
      html += `<div class="kraal-iw__meta-row"><span>Days in feedlot</span><span>${detail.daysInFeedlot}</span></div>`;
    }
    if (detail.owner) {
      html += `<div class="kraal-iw__meta-row"><span>Owner</span><span>${this.escapeHtml(detail.owner)}</span></div>`;
    }
    if (detail.lotDescription) {
      html += `<div class="kraal-iw__meta-row"><span>Lot</span><span>${this.escapeHtml(detail.lotDescription)}</span></div>`;
    }
    html += `</div>`;
    html += `<div class="kraal-iw__section"><div class="kraal-iw__section-title">Deliveries</div>`;
    if (detail.deliveries.length) {
      html += `<ul class="kraal-iw__deliveries">`;
      detail.deliveries.forEach((delivery) => {
        const status = delivery.active ? ' <span class="kraal-iw__status">active</span>' : "";
        html += `<li>${this.escapeHtml(delivery.label)}: ${this.escapeHtml(this.formatNumber(delivery.fed))} / ${this.escapeHtml(
          this.formatNumber(delivery.allocated)
        )} kg${status}</li>`;
      });
      html += `</ul>`;
    } else {
      html += `<div class="kraal-iw__empty">No deliveries recorded yet.</div>`;
    }
    html += `</div>`;
    if (detail.notes) {
      html += `<div class="kraal-iw__section"><div class="kraal-iw__section-title">Notes</div><div class="kraal-iw__notes">${this.escapeHtml(
        detail.notes
      )}</div></div>`;
    }
    html += `</div>`;
    return html;
  }
  async getKmlFile() {
    let url = `${this.$store.getters["backendUrl"]()}/kmlFilename`;
    let jwt = await this.$store.dispatch("user/getOnlineIdToken", undefined, { root: true });
    let res = await fetch(url, {
      method: "GET",
      headers: new Headers({ Authorization: `Bearer ${jwt}` }),
    });
    if (!res.ok) throw Error("Response OK : " + (await res.text()));
    let data = await res.json();
    console.log(data);
    this.kmlFilename = data;
  }
  getTrailerName(guid: string) {
    let trailers = this.$store.getters[`storage`]().Trailers as Model.Trailer[];
    let trailer = lodash.find(trailers, { electronicID: guid });
    if (trailer) return trailer.wagonRegistration;
  }
  getTractorName(guid: string) {
    let tractors = this.$store.getters[`storage`]().Tractors as Model.Tractor[];
    let tractor = lodash.find(tractors, { electronicID: guid });
    if (tractor) return tractor.registrationNumber;
  }
  graphQLSubscriber: any = undefined;
  graphQLUnsubscribe: any = undefined;
  graphQLSubscriber2: any = undefined;
  graphQLUnsubscribe2: any = undefined;
  destroyed() {
    if (this.graphQLUnsubscribe) {
      this.graphQLUnsubscribe();
    }
    if (this.graphQLSubscriber) {
      this.graphQLSubscriber();
    }
    if (this.graphQLUnsubscribe2) {
      this.graphQLUnsubscribe2();
    }
    if (this.graphQLSubscriber2) {
      this.graphQLSubscriber2();
    }
  }
  async getGPSCoordinatesSocket() {
    if (this.$store.state.useP2PConn) {
      await this.getOnlineGPSCoordinatesSocket();
    } else {
      await this.getOnsiteGPSCoordinatesSocket();
    }
  }
  async getOnsiteGPSCoordinatesSocket() {
    this.graphQLSubscriber2 = Subscriber.graphQLReconnectingSubscriber(
      this.urlws,
      this.options,
      (error: any, subscribe: any) => {
        try {
          if (!(error || subscribe)) {
            // Normal closure.
            console.log("connected to socket");
            this.$store.state.wsDialogVisible = false;
            return;
          }
          if (error) {
            console.log("error connecting to socket");
            if (error.details[0].message === "close") {
            } else {
              this.$store.state.wsDialogVisible = true;
              console.error(error);
            }
          }
          console.log("socket connected");
          this.graphQLUnsubscribe2 = subscribe(this.coordinateSubscription, this.variables, this.operationName, (error: any, data: any) => {
            if (!(error || subscribe)) {
              console.log("subscribe success");
              // Normal closure
              this.$store.state.wsDialogVisible = false;
              return;
            }
            if (error) {
              console.log("error subscribing");
              if (error.details[0].message === "close") {
              } else {
                this.$store.state.wsDialogVisible = true;
                console.error(error.details[0]);
              }
            }
            this.$store.state.wsDialogVisible = false;
            if (data) this.gpsCoordinates = JSON.parse(data.gpsLocations);
            this.loading = false;
          });
        } catch (err) {
          //show offline maybe
          //  this.$store.state.wsDialogVisible = true;
        }
      },
      15000,
      3,
      "graphql-ws"
    );
  }
  async getOnlineGPSCoordinatesSocket() {
    let variables = { guid: this.$store.state.user.location.guid, user: this.$store.state.user.user.uid };
    const subscribe = (subscriptions: string, variables: any, callback: (error: any, data: any) => Promise<void>) => {
      const client = createClient();
      let unsubscribe = client?.subscribe(
        {
          query: subscriptions,
          variables: variables,
        },
        {
          next: (message: any) => callback(undefined, message.data),
          error: (err: any) => {
            throw err;
          },
          complete: () => console.log("subscription completed"),
        }
      );
      return unsubscribe;
    };
    this.graphQLUnsubscribe = subscribe(this.coordinateSubscription, variables, async (error: any, data: any) => {
      this.$store.state.wsConnected = true;
      if (!(error || subscribe)) {
        console.log("subscribe success");
        this.$store.state.wsDialogVisible = false;
        // Normal closure
        return;
      }
      if (error) {
        console.log("error subscribing");
        this.$store.state.wsConnected = false;
        if (error.event.type === "close") {
        } else {
          this.$store.state.wsDialogVisible = true;
          console.error(error);
          //    throw error;
        }
      }
      this.$store.state.wsDialogVisible = false;
      this.$store.state.wsConnected = true;
      console.log("almost there");
      if (data) this.gpsCoordinates = JSON.parse(data.gpsLocations);
      this.loading = false;
    });
  }
  async getGPSCoordinates() {
    this.loading = true;
    try {
      console.log("getGPSCoordinates()");
      let gql = this.coordinateQuery;
      let json = await this.$store.dispatch("graphQl", {
        gql,
        variables: { guid: this.$store.state.user.location.guid },
        url: "https://pi.gigalot.systems:7777/feeder",
      });
      console.log("Done Downloading");
      this.gpsCoordinates = JSON.parse(json.data.GPSLocations);
    } catch (err) {
      console.log("getGPSCoordinates -> error: " + err);
    }
  }
  async getReplayTracking(playbackDate: string) {
    if (!playbackDate) playbackDate = new Date(Date.now()).toISOString().split("T")[0];
    this.clearTracks();
    console.log(playbackDate);
    let url = `${this.$store.getters["functionsUrl"]()}/replayTracking?startDate=${playbackDate}&endDate=${playbackDate}`;
    let jwt = await this.$store.dispatch("user/getOnlineIdToken", undefined, {
      root: true,
    });
    let res = await fetch(url, {
      method: "GET",
      mode: "cors",
      headers: new Headers({ Authorization: `Bearer ${jwt} ` }),
    });
    if (!res.ok) throw Error("Response OK : " + (await res.text()));
    let data = await res.json();
    console.log(data);
    this.replays = data;
    this.drawPolyline();
  }
  get moment() {
    return this.$store.state.moment;
  }
  get themeClass(): string {
    return this.$store.state.lightDarkMode;
  }

  get breadcrumbs() {
    return homeBreadcrumbs({ text: "Map", disabled: true });
  }
  get google() {
    return gmapApi;
  }
}
